import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiManagersRoleplayingConditionTemplateMutateType,
  ApiManagersRoleplayingConditionTemplateMutateRequestType,
} from "~/domains";

type RequestDataType = {
  id: string;
  body: ApiManagersRoleplayingConditionTemplateMutateRequestType;
};

const request = ({ id, body }: RequestDataType) => {
  return new ApiClient()
    .put<ApiManagersRoleplayingConditionTemplateMutateType>(
      `/api/managers/roleplaying_condition_templates/${id}`,
      {
        roleplayingConditionTemplate: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersRoleplayingConditionTemplatesUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersRoleplayingConditionTemplateMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
